import { action, computed } from "easy-peasy";
import { PUSHER_EVENTS_TYPES } from "./pusherModel";

export const MEDIA_EVENTS_TYPES = {
    MOVIE: 1,
    MOVIE_THUMBNAIL: 2,
    MOVIE_TRAILER: 3,
    SCENE: 4,
    SCENE_THUMBNAIL: 5,
    SCENE_THUMBNAIL_VIDEO: 6
}

const removeKey = (obj, keyToRemove) => {
    const { [keyToRemove]: _, ...rest } = obj;
    return rest;
}

export const mediaLogsModel = {
    lastEvent: null,
    movieRefetchId: 0,
    sceneRefetchId: 0,
    trailerEvents: {},
    sceneEvents: {},
    sceneThumbnailEvents: {},
    sceneThumbnailVideoEvents: {},
    movieEvents: {},
    setEvent: action((state, payload) => {
        const event = {
            ...payload.data,
            eventId: new Date().getTime(),
        }
        state.lastEvent = event;
        switch (+payload.type) {
            case PUSHER_EVENTS_TYPES.REFETCH_MOVIE: {
                state.movieRefetchId = payload?.data?.movie_id ?? 0;
                break;
            }
            case PUSHER_EVENTS_TYPES.MOVIE_TRAILER_LOGS: {
                const events = state.trailerEvents?.[event.relation_id] || [];
                const trailerEvents = new Map(events.map(event => [Number(event.step), event]));
                const log = trailerEvents.get(Number(event.step));
                if (log) {
                    trailerEvents.set(Number(event.step), {
                        ...log,
                        status: event.status,
                        step: event.step ?? log.step,
                    });
                } else {
                    trailerEvents.set(Number(event.step), event)
                }
                state.trailerEvents = Array.from(trailerEvents.values()).sort((a, b) => a.step - b.step);
                break;
            }
            case PUSHER_EVENTS_TYPES.REFETCH_SCENE: {
                state.sceneRefetchId = payload?.data?.scene_id ?? 0;
                break;
            }
            case PUSHER_EVENTS_TYPES.SCENE_THUMBNAIL_VIDEO_LOGS: {
                const events = state.sceneThumbnailVideoEvents?.[event.relation_id] || [];
                const sceneThumbnailVideoEvents = new Map(events.map(event => [Number(event.step), event]));
                const log = sceneThumbnailVideoEvents.get(Number(event.step));
                if (log) {
                    sceneThumbnailVideoEvents.set(Number(event.step), {
                        ...log,
                        status: event.status,
                        step: event.step ?? log.step,
                    });
                } else {
                    sceneThumbnailVideoEvents.set(Number(event.step), event)
                }
                state.sceneThumbnailVideoEvents[event.relation_id] = Array.from(sceneThumbnailVideoEvents.values()).sort((a, b) => a.step - b.step);
                break;
            }
            case PUSHER_EVENTS_TYPES.SCENE_LOGS: {
                const events = state.sceneEvents?.[event.relation_id] || [];
                const sceneEvents = new Map(events.map(event => [Number(event.step), event]));
                const log = sceneEvents.get(Number(event.step));
                if (log) {
                    sceneEvents.set(Number(event.step), {
                        ...log,
                        status: event.status,
                        step: event.step ?? log.step,
                    });
                } else {
                    sceneEvents.set(Number(event.step), event)
                }
                state.sceneEvents[event.relation_id] = Array.from(sceneEvents.values()).sort((a, b) => a.step - b.step);
                break;
            }
            case PUSHER_EVENTS_TYPES.SCENE_THUMBNAIL_LOGS: {
                const events = state.sceneThumbnailEvents?.[event.relation_id] || []
                const sceneThumbEvents = new Map(events.map(event => [Number(event.step), event]));
                const log = sceneThumbEvents.get(Number(event.step));
                if (log) {
                    sceneThumbEvents.set(Number(event.step), {
                        ...log,
                        status: event.status,
                        step: event.step ?? log.step,
                    });
                } else {
                    sceneThumbEvents.set(Number(event.step), event)
                }
                state.sceneThumbnailEvents[event.relation_id] = Array.from(sceneThumbEvents.values()).sort((a, b) => a.step - b.step);
                break;
            }
            case PUSHER_EVENTS_TYPES.MOVIE_LOGS: {
                const events = state.movieEvents?.[event.relation_id] || [];
                const movieEvents = new Map(events.map(event => [Number(event.step), event]));
                const log = movieEvents.get(Number(event.step));
                if (log) {
                    movieEvents.set(Number(event.step), {
                        ...log,
                        status: event.status,
                        step: event.step ?? log.step,
                    });
                } else {
                    movieEvents.set(Number(event.step), event)
                }
                state.movieEvents[event.relation_id] = Array.from(movieEvents.values()).sort((a, b) => a.step - b.step);
                break;
            }
        }
    }),
    clearMovieRefetchId: action((state, payload) => {
        state.movieRefetchId = 0;
    }),
    clearSceneRefetchId: action((state, payload) => {
        state.sceneRefetchId = 0;
    }),
    clearMovies: action((state, payload) => {
        if (!payload) return;
        state.movieEvents = removeKey(state.movieEvents, payload);
        state.trailerEvents = removeKey(state.trailerEvents, payload);
        state.movieRefetchId = 0;
    }),
    clearScenes: action((state, payload) => {
        state.sceneEvents = removeKey(state.sceneEvents, payload);
        state.sceneThumbnailVideoEvents = removeKey(state.sceneThumbnailVideoEvents, payload);
        state.sceneThumbnailEvents = removeKey(state.sceneThumbnailEvents, payload);
        state.sceneRefetchId = 0;
    }),
    clearStepsByType: action((state, payload) => {
        switch (+payload) {
            case PUSHER_EVENTS_TYPES.MOVIE_TRAILER_LOGS: {
                state.trailerEvents = {};
                break;
            }
            case PUSHER_EVENTS_TYPES.SCENE_LOGS: {
                state.sceneEvents = {};
                break;
            }
            case PUSHER_EVENTS_TYPES.SCENE_THUMBNAIL_VIDEO_LOGS: {
                state.sceneThumbnailVideoEvents = {};
                break;
            }
            case PUSHER_EVENTS_TYPES.SCENE_THUMBNAIL_LOGS: {
                state.sceneThumbnailEvents = {};
                break;
            }
            case PUSHER_EVENTS_TYPES.MOVIE_LOGS: {
                state.movieEvents = {};
                break;
            }
        }
    }),
    getEventsByType: computed((state) => {
        return (type) => {
            switch (type) {
                case PUSHER_EVENTS_TYPES.MOVIE_TRAILER_LOGS:
                    return state.trailerEvents;
                case PUSHER_EVENTS_TYPES.SCENE_LOGS:
                    return state.sceneEvents;
                case PUSHER_EVENTS_TYPES.SCENE_THUMBNAIL_VIDEO_LOGS:
                    return state.sceneThumbnailVideoEvents;
                case PUSHER_EVENTS_TYPES.SCENE_THUMBNAIL_LOGS:
                    return state.sceneThumbnailEvents;
                case PUSHER_EVENTS_TYPES.MOVIE_LOGS:
                    return state.movieEvents;
            }
        }
    }),
}